/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Table } from "antd";

const NewDatatable = ({
  props,
  columns,
  dataSource,
  bordered = false,
  stickyHeader = false,
  showSlno = true,

  // 🔥 server-side pagination props
  currentPage,
  pageSize,
  totalRecords,
  onPageChange,
}) => {
  const [searchText, setSearchText] = useState("");
  const [filteredDataSource, setFilteredDataSource] = useState(dataSource);

  useEffect(() => {
    setFilteredDataSource(dataSource);
  }, [dataSource]);

  const handleSearch = (value) => {
    setSearchText(value);
    const filteredData = dataSource.filter((record) =>
      Object.values(record).some((field) =>
        String(field).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredDataSource(filteredData);
  };

  // inject sl.no column only if enabled
  const modifiedColumns = showSlno
    ? [
        {
          title: "Sl. No",
          key: "slno",
          width: 80,
          render: (_, __, index) =>
            (currentPage - 1) * pageSize + index + 1,
        },
        ...columns,
      ]
    : columns;

  return (
    <>
      {/* Search UI (unchanged) */}
      <div className="search-set table-search-set">
        <div className="search-input">
          <a href="#" className="btn btn-searchset">
            <i className="ti ti-search fs-14 feather-search" />
          </a>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              <input
                type="search"
                onChange={(e) => handleSearch(e.target.value)}
                className="form-control form-control-sm"
                placeholder="Search"
              />
            </label>
          </div>
        </div>
      </div>

      {/* Table */}
      <Table
        key={props}
        className="table datanew dataTable no-footer"
        columns={modifiedColumns}
        dataSource={filteredDataSource}
        rowKey={(record) => record.id}
        bordered={bordered}
        scroll={{
          x: "max-content",
          ...(stickyHeader && { y: 500 }),
        }}
        pagination={{
            locale: { items_per_page: "" },
          current: currentPage,
          pageSize: pageSize,
          total: totalRecords,
          showSizeChanger: true,
          pageSizeOptions: ["100", "200", "300"],
          nextIcon: (
            <span>
              <i className="fa fa-angle-right" />
            </span>
          ),
          prevIcon: (
            <span>
              <i className="fa fa-angle-left" />
            </span>
          ),
          onChange: (page, size) => {
            onPageChange(page, size); // 🔥 call parent
          },
        }}
      />
    </>
  );
};

export default NewDatatable;
